import { plainToClass } from 'class-transformer';
import { BaseApi } from './base.api';
import { FindAllResponse } from '../types';
import { API_LEADERSHIP_DASHBOARD } from '../api.routes';
import { LeadershipDashboardDto } from '../dto/leadership-dashboard.dto';

export class LeadershipDashboardApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<LeadershipDashboardDto>> {
    return this.httpClient
      .get(API_LEADERSHIP_DASHBOARD, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(LeadershipDashboardDto, data.items)
        };
      });
  }
}
